import { MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { COLOR_BLACK_HAZE, COLOR_DENIM, COLOR_REGENT_ST_BLUE } from '../../popTheme';

export const ProvinceSelect = ({ sxprops, inputProps, ...props }) => {
  const intl = useIntl();

  const messages = defineMessages({
    ontario: {
      id: 'register.province.ontario',
      defaultMessage: 'Ontario',
    },
    quebec: {
      id: 'register.province.quebec',
      defaultMessage: 'Quebec',
    },
    novaScotia: {
      id: 'register.province.nova_scotia',
      defaultMessage: 'Nova Scotia',
    },
    newBrunswick: {
      id: 'register.province.new_brunswick',
      defaultMessage: 'New Brunswick',
    },
    manitoba: {
      id: 'register.province.manitoba',
      defaultMessage: 'Manitoba',
    },
    britishColumbia: {
      id: 'register.province.british_columbia',
      defaultMessage: 'British Columbia',
    },
    princeEdwardIsland: {
      id: 'register.province.prince_edward_island',
      defaultMessage: 'Prince Edward Island',
    },
    saskatchewan: {
      id: 'register.province.saskatchewan',
      defaultMessage: 'Saskatchewan',
    },
    alberta: {
      id: 'register.province.alberta',
      defaultMessage: 'Alberta',
    },
    newfoundlandAndLabrador: {
      id: 'register.province.newfoundland_and_labrador',
      defaultMessage: 'Newfoundland and Labrador',
    },
    northwestTerritories: {
      id: 'register.province.northwest_territories',
      defaultMessage: 'Northwest Territories',
    },
    yukon: {
      id: 'register.province.yukon',
      defaultMessage: 'Yukon',
    },
    nunavut: {
      id: 'register.province.nunavut',
      defaultMessage: 'Nunavut',
    },
  });

  const provinces = [
    {
      display: intl.formatMessage(messages.ontario),
      value: 'Ontario',
    },
    {
      display: intl.formatMessage(messages.quebec),
      value: 'Quebec',
    },
    {
      display: intl.formatMessage(messages.novaScotia),
      value: 'Nova Scotia',
    },
    {
      display: intl.formatMessage(messages.newBrunswick),
      value: 'New Brunswick',
    },
    {
      display: intl.formatMessage(messages.manitoba),
      value: 'Manitoba',
    },
    {
      display: intl.formatMessage(messages.britishColumbia),
      value: 'British Columbia',
    },
    {
      display: intl.formatMessage(messages.princeEdwardIsland),
      value: 'Prince Edward Island',
    },
    {
      display: intl.formatMessage(messages.saskatchewan),
      value: 'Saskatchewan',
    },
    {
      display: intl.formatMessage(messages.alberta),
      value: 'Alberta',
    },
    {
      display: intl.formatMessage(messages.newfoundlandAndLabrador),
      value: 'Newfoundland and Labrador',
    },
    {
      display: intl.formatMessage(messages.northwestTerritories),
      value: 'Northwest Territories',
    },
    {
      display: intl.formatMessage(messages.yukon),
      value: 'Yukon',
    },
    {
      display: intl.formatMessage(messages.nunavut),
      value: 'Nunavut',
    },
  ];

  const renderProvinces = () => {
    let provList = [];
    for (let i = 0; i < provinces.length; i++) {
      provList.push(
        <MenuItem key={i + 1} value={provinces[i].value}>
          <Typography variant="body1" color={COLOR_DENIM}>
            {provinces[i].display}
          </Typography>
        </MenuItem>,
      );
    }
    return provList;
  };

  return (
    <Select
      {...props}
      fullWidth
      size="small"
      inputProps={{ ...inputProps }}
      sx={{
        ...sxprops,
        bgcolor: COLOR_BLACK_HAZE,
        borderRadius: '0.375rem',
        borderColor: COLOR_REGENT_ST_BLUE,
      }}
    >
      {renderProvinces()}
    </Select>
  );
};
